export default __webpack_public_path__ + "static/giotto-2-638d23f78cd0b42f32dca5d8e630af92.jpg";